import PropTypes from 'prop-types';

const { string, func, object, shape, any } = PropTypes;

const funcReq = func.isRequired;

const intlConfigPropTypes = {
	locale: string,
	timeZone: string,
	formats: object,
	messages: object,
	textComponent: any,
	defaultLocale: string,
	defaultFormats: object,
	onError: func,
};

const intlFormatPropTypes = {
	formatDate: funcReq,
	formatTime: funcReq,
	formatRelativeTime: funcReq,
	formatNumber: funcReq,
	formatPlural: funcReq,
	formatMessage: funcReq,
	formatHTMLMessage: funcReq,
};
// react-intl v3 was rewritten in TypeScript and intlShape was removed as an export and changed to
// TypeScript interface which we currenty can't use
// as a workaround here is the
// v2 intlShape
// https://github.com/formatjs/react-intl/blob/2.x/src/types.js
// v3 intlShape
// https://github.com/formatjs/react-intl/blob/master/docs/API.md#intlshape
export const intlShape = shape({
	...intlConfigPropTypes,
	...intlFormatPropTypes,
});
